import { render, staticRenderFns } from "./ProximaVisitaFraude.vue?vue&type=template&id=e4729bcc&scoped=true"
import script from "./ProximaVisitaFraude.vue?vue&type=script&lang=js"
export * from "./ProximaVisitaFraude.vue?vue&type=script&lang=js"
import style0 from "./ProximaVisitaFraude.vue?vue&type=style&index=0&id=e4729bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4729bcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
